import React from 'react';

import * as Styled from './Features.styles';
import Feature from 'components/Feature/Feature';

export interface FeaturesProps {}

const Features: React.FC<FeaturesProps> = () => {
  return <Styled.Wrapper>
    <Feature />
  </Styled.Wrapper>;
};

export default Features;
